'use client';

import { useSyncExternalStore } from 'react';

const ANCHOR_JUMP_SCRIPT =
  "if(location.hash){document.documentElement.setAttribute('data-anchor-jump','');window.__anchorHash=location.hash;history.replaceState(null,'',location.pathname+location.search)}";

const subscribe = () => () => {};

/**
 * Anchor deep links: flags `data-anchor-jump` before first paint so reveals don't hide the target
 * (AppShellEffects takes over after hydration). Rendered only into the server HTML (and kept during
 * its hydration): when the root layout mounts again in the browser — a locale change remounts
 * `<html>`, dev not-found/HMR — React would create a fresh, never-executed <script> and warn
 * ("Encountered a script tag while rendering React component"), so nothing is rendered then.
 */
export const AnchorJumpScript = () => {
  const isClientMount = useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
  return isClientMount ? null : <script dangerouslySetInnerHTML={{ __html: ANCHOR_JUMP_SCRIPT }} />;
};
